const getItem = (key:string) => {
  if (typeof window === 'undefined') return null;
  
  try {
    const data = localStorage.getItem(key);
    if (data === null) return null;
    
    // Para tokens JWT, no necesitan ser parseados como JSON
    if (key === 'access_token' || key === 'refresh_token') {
      return data;
    }
    
    // Para otros datos, intentar parsear como JSON
    try {
      const parsed = JSON.parse(data);
      return parsed;
    } catch (jsonErr) {
      // Si no es JSON válido, devolver como string
      return data;
    }
  } catch (err) {
    console.warn(`Error al obtener localStorage para ${key}:`, err);
    // Si hay error, limpiar el item corrupto
    localStorage.removeItem(key);
    return null;
  }
};

const setItem = (key:string, value:any) => {
  if (typeof window === 'undefined') return;
  
  try {
    // Para tokens JWT, guardar como string directamente
    if (key === 'access_token' || key === 'refresh_token') {
      localStorage.setItem(key, String(value));
    } else {
      // Para otros datos, convertir a JSON si no es string
      const stringify = typeof value !== 'string' ? JSON.stringify(value) : value;
      localStorage.setItem(key, stringify);
    }
  } catch (err) {
    console.error(`Error al guardar en localStorage para ${key}:`, err);
    // Si hay error de almacenamiento, limpiar localStorage
    localStorage.clear();
  }
};

const removeItem = (key:string) => {
  if (typeof window === 'undefined') return;
  
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.error(`Error al eliminar de localStorage para ${key}:`, err);
  }
};

export { getItem, setItem, removeItem };
